import {
  CalendarIcon,
  GraphIcon,
  HouseIcon,
  PastRecoveryIcon,
  RatingIcon,
  TimeRecoveryIcon,
  Envelope2Icon,
  VesselIcon,
  FleetPerformanceIcon,
  VesselProfilerIcon,
  EeoiIcon,
  FoulingSimulatorIcon,
  AiChatbotIcon,
} from '@atoms/index';
import { ComponentWithAs, IconProps } from '@chakra-ui/react';

export type SidebarIcon = Record<NavigationIcons, ComponentWithAs<'svg', IconProps>>;

export enum NavigationIcons {
  /**
   * Icon for the house.
   */
  HOUSE = 'HOUSE',
  /**
   * Icon for the rating.
   */
  RATING = 'RATING',
  /**
   * Icon for the graph.
   */
  GRAPH = 'GRAPH',
  /**
   * Icon for the calendar.
   */
  CALENDAR = 'CALENDAR',
  /**
   * Icon Icon for the time recovery.
   */
  TIME_RECOVERY = 'TIME_RECOVERY',
  /**
   * Icon for past recovery.
   */
  PAST_RECOVERY = 'PAST_RECOVERY',
  /**
   * Icon for envelope.
   */
  ENVELOPE = 'ENVELOPE',
  /**
   * Icon for vessel.
   */
  VESSEL = 'VESSEL',
  /**
   * Icon for fleet performance.
   */
  FLEET_PERFORMANCE = 'FLEET_PERFORMANCE',
  /**
   * Icon for vessel profiler.
   */
  VESSEL_PROFILER = 'VESSEL_PROFILER',
  /**
   * Icon for EEOI.
   */
  EEOI = 'EEOI',
  /**
   * Icon for fouling simulator.
   */
  FOULING_SIMULATOR = 'FOULING_SIMULATOR',
  /**
   * Icon for AI Chatbot.
   */
  AI_CHATBOT = 'AI_CHATBOT',
}

/**
 * Represents the mapping of sidebar icons to their respective component icons.
 */
export const iconsMap: SidebarIcon = {
  [NavigationIcons.HOUSE]: HouseIcon,
  [NavigationIcons.RATING]: RatingIcon,
  [NavigationIcons.GRAPH]: GraphIcon,
  [NavigationIcons.CALENDAR]: CalendarIcon,
  [NavigationIcons.TIME_RECOVERY]: TimeRecoveryIcon,
  [NavigationIcons.PAST_RECOVERY]: PastRecoveryIcon,
  [NavigationIcons.ENVELOPE]: Envelope2Icon,
  [NavigationIcons.VESSEL]: VesselIcon,
  [NavigationIcons.FLEET_PERFORMANCE]: FleetPerformanceIcon,
  [NavigationIcons.VESSEL_PROFILER]: VesselProfilerIcon,
  [NavigationIcons.EEOI]: EeoiIcon,
  [NavigationIcons.FOULING_SIMULATOR]: FoulingSimulatorIcon,
  [NavigationIcons.AI_CHATBOT]: AiChatbotIcon,
};
